import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const NicePayResult = () => {
  return <CommonResult />;
};

export default NicePayResult;
